import Intro from "./components/Intro";
import Footer from "./components/Footer";
import Instructors from "./components/Instructors";
import Navbar from "./components/Navbar";
import About from "./components/About";
import Presentation from "./components/Presentation";
// import FixedUpButton from "./components/FixedUpButton";
import banner from "./assets/images/banner_new.jpeg";
import ProjectManager from "./components/ProjectManager";
import OrganizationCommittee from "./components/OrganizationCommittee";

function App() {
  return (
    <>
      <Navbar />
      <img src={banner} alt="asd" className="banner" />
      <Intro />
      <Presentation />
      <About />
      <ProjectManager />
      <OrganizationCommittee />
      <Instructors />
      {/* <FixedUpButton /> */}
      <Footer />
    </>
  );
}

export default App;
